import "./twritting.css";
import gitAction from "../../assets/gitAction.png";
const Twritting = () => {
  return (
    <section id="tWritting">
      <h2 className="portHeading">Technical Writting</h2>
      <div className="portLayout">
        <div className="column">
          {/* Auto Card */}
          <div className="card tcard">
            <div className="cardImg">
              <img src={gitAction} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">Auto Accept Collaborators</span>
              <p className="projectP">
                As an educator, I receive at least five collaborator requests
                daily, and manually accepting each one before the three-day
                expiration has become a repetitive and time-consuming task.
                However, implementing workflows can be challenging—especially
                for those unfamiliar with them. To address this, I repurposed my
                README as a step-by-step tutorial to help others implement this
                workflow more easily.
              </p>
              <div className="tags">
                <div className="tag">Github Actions</div>
                <div className="tag">Work Flows</div>
                <div className="tag">Tailwind </div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/auto_accept_collaborators"
                  className="cardLink"
                >
                  Review repo
                </a>
                {/* <a href="https://ed-facts.vercel.app/" className="cardLink">
                  View site
                </a> */}
              </div>
            </div>
          </div>
          {/* Understanding JS Event Loop Card */}
          <div className="card tcard">
            <div className="cardImg">
              <img src={gitAction} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">
                Understanding The Javascript Eventloop
              </span>
              <p className="projectP">
                This project uses an interactive Cooking Game to help students
                understand how JavaScript’s event loop and Promises work through
                a fun, real-world analogy. By observing how tasks are sequenced
                while cooking pasta in the game, students will map each step to
                an event loop phase (e.g., call stack, microtask queue, task
                queue). The goal is to demystify asynchronous JavaScript
                behavior—including setTimeout, .then(), and the difference
                between microtasks and macrotasks—by grounding abstract concepts
                in a visual, hands-on experience.
              </p>
              <div className="tags">
                <div className="tag">Event Loop</div>
                <div className="tag">Javascript</div>
                <div className="tag">Learning Activity </div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/cookingGame/blob/main/README.md"
                  className="cardLink"
                >
                  Review repo
                </a>
                <a
                  href="https://cooking-game-six.vercel.app/index.html"
                  className="cardLink"
                >
                  View site
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="column">
          {/* Holiday API Card */}
          <div className="card tcard">
            <div className="cardImg">
              <img src={gitAction} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">Holiday API</span>
              <p className="projectP">
                This write up will help others create a custom API using Node.js
                and Express.js. The backend API will be deployed onto Heroku
                then create a frontend that will consume the API which will be
                built using HTML and Javascript. The application is simple in
                nature. It is intended to be a learning tool to teach the
                process of using Node and Express.
              </p>
              <div className="tags">
                <div className="tag">Express</div>
                <div className="tag">API</div>
                <div className="tag">Heroku</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/holiday-api-tutorial"
                  className="cardLink"
                >
                  Review repo
                </a>
                {/* <a
                  href="https://amplify-app-production.herokuapp.com/"
                  className="cardLink"
                >
                  View site
                </a> */}
              </div>
            </div>
          </div>
          {/* Open-Source Card */}
          <div className="card tcard">
            <div className="cardImg">
              <img src={gitAction} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">Open-Source Welcome Action</span>
              <p className="projectP">
                This article is a walk through tutorial on how to use GitHub
                actions to create a welcoming environment for first time open
                source contributors.
              </p>
              <div className="tags">
                <div className="tag">GitAction</div>
                <div className="tag">YAML</div>
                <div className="tag">Dev.to</div>
              </div>
              <div className="links">
                <a
                  href="https://dev.to/programequity/how-to-welcome-first-time-contributors-to-your-repository-using-github-actions-390p"
                  className="cardLink"
                >
                  Read Blog
                </a>
                {/* <a href="https://amplify-app-production.herokuapp.com/" className="cardLink">View Site</a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Twritting;
